module.exports = __webpack_public_path__ + "media/images/brunet 2-4b3413e51929553a846a2bf6833cefd1.jpg";